import React from "react";
import { ButtonGroup,Button } from "shards-react";

const renderCategories = (post) => {
  let content = [];
  post.forEach((item, i) =>{
     
        content.push(
          <ButtonGroup className="mb-3">     
            <Button theme="white" key={item.key}>{item.name}</Button>
         </ButtonGroup>
        )
    
  });
  return content;
}

const RowImages = ({ chips }) => {


  return (
    <div>
       {chips!=undefined ? 
      renderCategories(chips)
      : ''}
  
    </div>
  )
   
};



export default RowImages;
